import React, { FC } from 'react';
import clsx from 'clsx';
import { createUseStyles } from '../../../../../theming';

interface Props {
  label: string;
  color: string;
  onClick: () => void;
  active?: boolean;
  className?: string;
}

const useStyles = createUseStyles({
  root: ({ color }) => ({
    display: 'flex',
    background: 'white',
    padding: '2px 8px',
    borderRadius: 3,
    border: '1px solid #cacaca',
    borderLeft: `5px solid ${color}`,
    transition: '250ms',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 9px 0px rgba(0,0,0,0.3)',
    },
    '&$active': {
      boxShadow: '0px 0px 9px 0px rgba(0,0,0,0.3)',
    },
  }),
  active: {},
});

const Pill: FC<Props> = ({ className, active, label, color, ...props }) => {
  const classes = useStyles({ color });

  return (
    <div className={clsx(className, classes.root, { [classes.active]: active })} {...props}>
      {label}
    </div>
  );
};

export default Pill;
